import React, { PropsWithChildren, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useAddress from 'hooks/use-address';
import { useLoadCurrentSafe } from 'hooks/useLoadCurrentSafe';
import { getStorageKeysForNetwork } from 'utils/LocalstorageUtils';

type Props = {
  isAuthorizedOnly?: boolean;
};

export const RouteGuard: React.FC<PropsWithChildren<Props>> = ({ children, isAuthorizedOnly }) => {
  const history = useHistory();
  const walletAccount = useAddress();

  useLoadCurrentSafe();

  useEffect(() => {
    const storageKeys = getStorageKeysForNetwork();
    // using value from useAuthorized here leads to premature redirect
    // TODO either change useAuthorized hook to get value from local store on init or somehow wait for initialization
    const isAuthorized = localStorage.getItem(storageKeys.asignaWalletId);
    if (isAuthorizedOnly && !isAuthorized) {
      history.push('/connect');
    }
  }, [isAuthorizedOnly, walletAccount]);

  return <>{children}</>;
};
